export const MARKET_SUGGESTION_HANDLER = 'market';
export const ADMIN_USER_ADMIN_SUGGESTION_HANDLER = 'adminUserAdmin';
export const BUSINESS_RELATIONSHIP_SUGGESTION_HANDLER = 'businessRelationships';
export const CBI_ENTITY_SUGGESTION_HANDLER = 'cbiEntity';
